
window.addEventListener("load", function () {
    if ($('#nth-ms-event-list').length > 0) {
        
        $('html').addClass('fix-mobile')

    }

});